import React from "react";
import { Loader } from "./StyledSpinner";
import Logo from "../../assets/images/kkk.gif";
import Backdrop from "../Backdrop/Backdrop";
import Spinner from "react-bootstrap/Spinner";

interface SpinnerProps {
  backDrop: boolean;
}

const SpinnerSelf: React.FC<SpinnerProps> = (props) => {
  return (
    <Backdrop backDrop={props.backDrop}>
      <div
        style={{
          display: "flex",
          width: "100vw",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner animation="border" role="status" color="#e6662c">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
      {/* <Loader><img src={Logo} alt="Logo of the company" /> </Loader> */}
    </Backdrop>
  );
};

export default SpinnerSelf;
